import React, { createContext, useState, useEffect, useContext } from "react";

// Create Context
const KlinischerBefundContext = createContext();

// Provider Component
export const KlinischerBefundProvider = ({ children }) => {
  const [data, setData] = useState(() => {
    const saved = localStorage.getItem("klinischerBefund");
    if (saved) {
      const parsed = JSON.parse(saved);
      return { ...parsed };
    }

    // Default empty values
    return {
      linksMikrofilament: "",
      rechtsMikrofilament: "",
      linksVibrationsempfindung: "",
      rechtsVibrationsempfindung: "",
      linksHinweisPNP: "",
      rechtsHinweisPNP: "",
      linksHinweisPAVK: "",
      rechtsHinweisPAVK: "",
    };
  });

  // Persist to localStorage on change
  useEffect(() => {
    const dataToSave = { ...data };
    localStorage.setItem("klinischerBefund", JSON.stringify(dataToSave));
  }, [data]);

  // Clear function
  const clearKlinischerBefund = () => {
    setData({
      linksMikrofilament: "",
      rechtsMikrofilament: "",
      linksVibrationsempfindung: "",
      rechtsVibrationsempfindung: "",
      linksHinweisPNP: "",
      rechtsHinweisPNP: "",
      linksHinweisPAVK: "",
      rechtsHinweisPAVK: "",
    });
    localStorage.removeItem("klinischerBefund");
  };

  return (
    <KlinischerBefundContext.Provider
      value={{ data, setData, clearKlinischerBefund }}
    >
      {children}
    </KlinischerBefundContext.Provider>
  );
};

// Custom Hook
export const useKlinischerBefund = () => {
  const context = useContext(KlinischerBefundContext);
  if (!context)
    throw new Error(
      "useKlinischerBefund must be used within KlinischerBefundProvider"
    );
  return context;
};
